export default "__VITE_ASSET__gdSX6fd1__"